import {Component, OnInit, ViewChild} from '@angular/core';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {DocumentService} from '@orga-app/providers/document.service';
import {AlertController, IonSlides, LoadingController, Platform} from '@ionic/angular';
import {WindowRefService} from '@orga-app/providers/window.service';
import {NotificationService} from '@orga-app/providers/notification.service';
import {select, Store} from '@ngrx/store';
import {Settings} from '@orga-app/settings/settings.model';
import {Observable} from 'rxjs';
import * as fromFunktionsbereichChecklistenAufgabenPage from './funktionsbereich-checklisten-aufgaben.reducer';
import {getInitialSlide, getSlideOps} from './funktionsbereich-checklisten-aufgaben.reducer';
import * as actionsUi from './funktionsbereich-checklisten-aufgaben.actions.ui';
import * as  apiVeranstaltungen from '../../../../clients/veranstaltungen';
import {DocumentViewer, DocumentViewerOptions} from '@ionic-native/document-viewer/ngx';
import {File} from '@ionic-native/file/ngx';
import {FileOpener} from '@ionic-native/file-opener/ngx';
import {take, takeWhile} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {
    GetFunktionsbereichChecklistenAufgabenAction,
    PostChecklisteFreigebenAction
} from '../../../../client-ngrx/veranstaltungen';
import * as fromAppState from '../../app-state/app-state.reducer';
import {SafeUrl} from '@angular/platform-browser';
import {getPlatform} from '../../app-state/app-state.reducer';
import {SetzeAufgabeAction} from '../../app-state/actions/app-state.actions.ui';
import {PageStateResetAction} from '../aufgabe/aufgabe.actions.ui';
import {PhaseChecklisteAufgaben, PhasenChecklistenAufgaben} from '../../../../clients/veranstaltungen';
import {replaceSpecialCharacter} from '../../../shared/wrapper/stringWrapper';

declare const document;

@Component({
    selector: 'app-funktionsbereich-checklisten-aufgaben',
    templateUrl: './funktionsbereich-checklisten-aufgaben.page.html',
    styleUrls: ['./funktionsbereich-checklisten-aufgaben.page.scss'],
})

export class FunktionsbereichChecklistenAufgabenPage implements OnInit {
    @ViewChild('slides', {static: false}) slides: IonSlides;
    public aktuelleVeranstaltung$: Observable<apiVeranstaltungen.Veranstaltung>;
    public platformState$: Observable<string>;
    public platformState: string;
    funktionsbereich$: Observable<apiVeranstaltungen.Funktionsbereich>;
    checkliste$: Observable<apiVeranstaltungen.Checkliste>;
    public settings$: Observable<Settings>;
    public themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    public slideOps$: Observable<any>;
    public initialSlide$: Observable<number>;
    public phasenChecklistenAufgaben$: Observable<Array<apiVeranstaltungen.PhasenChecklistenAufgaben>>;
    public uiZeigeFbChecklistenAufgabenLaden$: Observable<boolean>;
    public uiZeigeFbChecklistenAufgabenLadenFehler$: Observable<boolean>;
    private aktuelleVeranstaltung: apiVeranstaltungen.Veranstaltung;
    private aktuelleVeranstaltungId: string;
    private aiName = 'FunktionsbereichChecklistenAufgabenPage';
    private alive = true;
    private windowLocal: Window;
    destroyPage = false;
    scrollToAufgabeId = 'FunktionsbereichChecklistenAufgabenPage::scrollToAufgabeId';

    currentAufgabeId = '';

    constructor(
        private store: Store<fromFunktionsbereichChecklistenAufgabenPage.PageState>,
        private storeVeranstaltung: Store<fromAppState.GlobalAppState>,
        public alertCtrl: AlertController,
        public platform: Platform,
        private notificationService: NotificationService,
        private windowRefService: WindowRefService,
        public file: File,
        public loadingCtrl: LoadingController,
        private documentService: DocumentService,
        private documentViewer: DocumentViewer,
        private settingsProvider: SettingsProvider,
        private fileOpener: FileOpener,
        public route: ActivatedRoute,
        public router: Router) {

        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.settingsProvider.getActiveTheme();
    }

    ngOnInit() {
        this.windowLocal = this.windowRefService.nativeWindow;

        this.aktuelleVeranstaltung$ = this.storeVeranstaltung.pipe(select(fromAppState.getAktuelleVeranstaltung));

        this.funktionsbereich$ = this.storeVeranstaltung.pipe(select(fromFunktionsbereichChecklistenAufgabenPage.getAktuellerFunktionsbereich));
        this.checkliste$ = this.storeVeranstaltung.pipe(select(fromFunktionsbereichChecklistenAufgabenPage.getAktuelleCheckliste));

        // Platform from State
        this.platformState$ = this.storeVeranstaltung.pipe(select(getPlatform));

        this.phasenChecklistenAufgaben$ = this.store.pipe(select(fromFunktionsbereichChecklistenAufgabenPage.getPhasenChecklistenAufgaben));
        this.uiZeigeFbChecklistenAufgabenLaden$ = this.store.pipe(select(fromFunktionsbereichChecklistenAufgabenPage.getUiZeigeFbChecklistenAufgabenLaden));
        this.uiZeigeFbChecklistenAufgabenLadenFehler$ = this.store.pipe(select(fromFunktionsbereichChecklistenAufgabenPage.getUiZeigeFbChecklistenAufgabenLadenFehler));
        this.slideOps$ = this.store.pipe(select(getSlideOps));
        this.initialSlide$ = this.store.pipe(select(getInitialSlide));
        /*this.initialSlide$.subscribe(x => {
            console.log('SlideTo: ', this.slides, x);
            if (this.slides !== undefined && this.slides !== null) {
                    this.slides.slideTo(x);
                }
            }
        );*/

        this.aktuelleVeranstaltung$.subscribe((aktuelleVeranstaltung) => {
            if (aktuelleVeranstaltung != null) {
                this.aktuelleVeranstaltungId = aktuelleVeranstaltung.veranstaltung_id;
                this.aktuelleVeranstaltung = aktuelleVeranstaltung;
            }
        });
        this.phasenChecklistenAufgaben$.subscribe((x) => {
            if (x) {
                const aufgabeId = localStorage.getItem(this.scrollToAufgabeId);
                if (aufgabeId) {
                    localStorage.removeItem(this.scrollToAufgabeId);

                    setTimeout(function () {
                        const elmnt = document.getElementById(aufgabeId);
                        if (elmnt) {
                            elmnt.scrollIntoView({behavior: 'auto', block: 'center', inline: 'nearest'});
                        }
                    }.bind(this), 100);
                }
                this.initialSlide$.subscribe(y => {
                        // console.log('SlideTo: ', this.slides, y);
                        if (this.slides !== undefined && this.slides !== null) {
                            this.slides.slideTo(y);
                        }
                    }
                ).unsubscribe();
            }
        });

        this.platformState$.subscribe(x => {
            this.platformState = x;
            if (x === 'desktop') {
                this.viewWillEnterPage().then();
            }
        }).unsubscribe();
    }

    ionViewWillEnter() {
        // console.log('viewwillenter fbclaufgaben');
        this.viewWillEnterPage().then();

    }

    async viewWillEnterPage() {
        await this.store.dispatch(new actionsUi.PageStateResetAction());
        await this.route.paramMap.subscribe(async (params) => {
            await this.store.dispatch(new actionsUi.SetzeFunktionsbereichAction(<apiVeranstaltungen.Funktionsbereich>{funktionsbereich_id: params.get('funktionsbereichId')}));
            await this.store.dispatch(new actionsUi.SetzeChecklisteAction(<apiVeranstaltungen.Checkliste>{checkliste_id: params.get('checklisteId')}));
            await this.funktionsbereichChecklistenAufgabenLaden();
        }).unsubscribe();
    }

    ionViewWillUnload() {
        this.initialSlide$.subscribe().unsubscribe();
    }

   /* async setSlideOps(initialSlide: number) {
        const ops = {initialSlide};
        console.log('setSlideOps: ', ops);
        await this.slidesOpts.next(ops);
    }*/

    // FUNKTIONSBEREICH CHECKLISTEN UND AUFGABEN LADEN
    async funktionsbereichChecklistenAufgabenLaden() {
        this.funktionsbereich$.subscribe(x => {
            if (x !== null && x.funktionsbereich_id !== undefined && x.funktionsbereich_id !== null) {
                this.store.dispatch(new GetFunktionsbereichChecklistenAufgabenAction(x.funktionsbereich_id));
            }
        }).unsubscribe();
    }

    // CHECKLISTEN
    async slideChanged($event) {
        // console.log('slideChanged', this.slides);
        this.phasenChecklistenAufgaben$.pipe(take(1)).subscribe(x => this.slides.getActiveIndex().then((index) => {
            this.store.dispatch(new actionsUi.SetzeChecklisteAction(x[index].checkliste));
            this.store.dispatch(new PageStateResetAction());
            // this.router.navigate(['/veranstaltung/' + x[index].checkliste.veranstaltung_id + '/funktionsbereiche-checklisten/funktionsbereich/' + x[index].checkliste.funktionsbereich_id + '/checkliste/' + x[index].checkliste.checkliste_id], {
            //     relativeTo: this.route.parent,
            //     skipLocationChange: true
            // });
        }));
    }

    async checklisteVor() {
        // this.slides.slideNext();
    }

    async checklisteFreigeben(checkliste: apiVeranstaltungen.Checkliste, phase: apiVeranstaltungen.Phase) {
        if (checkliste != null) {
            const prompt = await this.alertCtrl.create({
                header: 'Checkliste freigeben',
                message: 'Bitte nenne den Grund für die Freigabe der Checkliste <b>' + checkliste.titel + '</b>',
                inputs: [
                    {
                        name: 'freigabegrund',
                        placeholder: 'Freigabe Grund...',
                        id: 'alertInput'
                    },
                ],
                buttons: [
                    {
                        text: 'Abbrechen',
                        handler: data => {
                        }
                    },
                    {
                        text: 'Freigeben',
                        handler: data => {
                            const checklisteFreigebenRequest = <apiVeranstaltungen.ChecklisteFreigebenRequest>{
                                checkliste_id: checkliste.checkliste_id,
                                veranstaltung_id: checkliste.veranstaltung_id,
                                freigabe_text: data.freigabegrund,
                                funktionsbereich_id: checkliste.funktionsbereich_id,
                                zeitpunkt_utc: new Date(),
                                phase_id: phase.phase_id
                            };
                            this.store.dispatch(new PostChecklisteFreigebenAction(checklisteFreigebenRequest));
                        }
                    }
                ],
                cssClass: 'alertCustomCss'
            });
            prompt.present();
        }
    }

    // TODO: TZ Checkliste Prüfbericht laden und im Viever mit Share Option anzeigen
    async checklisteBerichtOeffnen(checkliste: apiVeranstaltungen.Checkliste) {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Prüfbericht für Checkliste ' + checkliste.titel + ' wird geladen'
        });
        await loading.present();

        const url = '/api/query/veranstaltungen/' + checkliste.veranstaltung_id + '/pruefbericht/funktionsbereiche/' + checkliste.funktionsbereich_id + '/checklisten/' + checkliste.checkliste_id; // + "?uploadId=" + checkliste.dokument_upload_id;
        this.documentService.getDocument(url).pipe(
            takeWhile(() => this.alive)
        ).subscribe(async (doc) => {
                if (doc != null) {
                    await loading.dismiss();
                    if (this.platformState === 'desktop') {
                        this.documentService.saveFile(doc, replaceSpecialCharacter(checkliste.titel));
                    } else {
                        this.file.removeFile(this.file.dataDirectory, replaceSpecialCharacter(checkliste.titel) + '.pdf').then((x) => {
                            this.writeFile(checkliste, doc);
                        }).catch((error) => {
                            this.writeFile(checkliste, doc);
                        });
                    }

                }
            },
            async (error) => {
                await this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                await loading.dismiss();
            }, () => {
            });

    }

    async writeFile(checkliste: apiVeranstaltungen.Checkliste, doc) {
        const options: DocumentViewerOptions = {
            title: checkliste.titel,
            documentView: {closeLabel: 'Schließen'},
            openWith: {enabled: true},
            email: {enabled: true}
        };

        // let x = Observable.fromPromise(this.file.writeFile(this.file.dataDirectory, dokument.dokument_id + '.pdf', document))
        const y = Observable.fromPromise(this.file.writeFile(this.file.dataDirectory, replaceSpecialCharacter(checkliste.titel) + '.pdf', doc))
            .subscribe((x) => {
                if (this.platform.is('ios')) {
                    const cacheDirectory = this.file.dataDirectory.replace('file://', '');
                    // this.documentViewer.viewDocument(cacheDirectory + dokument.dokument_id + '.pdf', 'application/pdf', options, this.onShowDocument, this.onCloseDocument, this.onMissingApp, this.onErrorDocument);
                    this.documentViewer.viewDocument(cacheDirectory + replaceSpecialCharacter(checkliste.titel) + '.pdf', 'application/pdf', options, this.onShowDocument, this.onCloseDocument, this.onMissingApp, this.onErrorDocument);
                } else {
                    this.fileOpener.open(
                        this.file.dataDirectory + replaceSpecialCharacter(checkliste.titel) + '.pdf',
                        'application/pdf'
                    ).then(() => console.debug('File is opened'))
                        .catch(e => {
                            console.debug('Error opening file', e);
                            this.documentViewer.viewDocument(this.file.dataDirectory + replaceSpecialCharacter(checkliste.titel) + '.pdf', 'application/pdf', options, this.onShowDocument, this.onCloseDocument, this.onMissingApp, this.onErrorDocument);
                        });
                }
            }, (error) => {
                console.error(error);
                this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
            });
    }

    async onShowDocument() {
    }

    async onCloseDocument() {
    }

    async onMissingApp(appId, installer) {
        if (confirm('Um das PDF ansehen zu können wird die kostenfreie PDF Viewer App benötigt. Jetzt installieren?')) {
            installer();
        }
    }

    async onErrorDocument(error) {
        window.console.error(error);
        this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
    }

    // AUFGABEN
    async aufgabeOeffnen(checkliste: apiVeranstaltungen.Checkliste, aufgabe: apiVeranstaltungen.Aufgabe) {
        localStorage.setItem(this.scrollToAufgabeId, aufgabe.aufgabe_id);

        if (aufgabe.aufgabe_id !== this.currentAufgabeId) {

            if (this.platformState === 'desktop') {
                this.storeVeranstaltung.dispatch(new SetzeAufgabeAction(aufgabe));
            } else {
                this.phasenChecklistenAufgaben$.pipe(take(1)).subscribe(x => this.slides.getActiveIndex().then((index) => {
                    this.router.navigate(['./aufgabe/' + aufgabe.aufgabe_id], {
                        relativeTo: this.route
                    });
                }));
            }
        }

        this.currentAufgabeId = aufgabe.aufgabe_id;
    }

    // async pageAktualisieren(refresher) {
    //     this.funktionsbereichChecklistenAufgabenLaden();
    //     refresher.complete();
    // }
    trackByAufgabe(index: number, aufgabe: apiVeranstaltungen.Aufgabe) {
        return aufgabe.aufgabe_id;
    }

    trackByPhasenChecklistenAufgaben(index: number, feld: PhasenChecklistenAufgaben) {
        if (feld.checkliste !== null) {
            return feld.checkliste.checkliste_id;
        } else {
            return index;
        }
    }

    trackByPhasen(index: number, feld: PhaseChecklisteAufgaben) {
        if (feld.checkliste !== null && feld.phase !== null) {
            return feld.checkliste.checkliste_id + feld.phase.phase_id;
        } else {
            return index;
        }
    }

    async pageAktualisieren(event) {
        await this.funktionsbereichChecklistenAufgabenLaden();
        setTimeout(async function() {
            await event.target.complete(); }.bind(this), 800);
    }
}
